// SocialDock.js — MOBILE uniquement. Un seul bouton flottant « Social » (à droite, au-dessus du chat) qui
// ouvre un DRAWER latéral DROIT regroupant les 3 sections sociales : Amis en ligne / Mes groupes / Mes
// messages. Évite d'empiler 3 languettes sur petit écran (le drawer gauche = navigation, celui-ci = social).
// Les 3 docks sont montés en mode "drawer" et remontent leur compteur → badge total sur le FAB (masqué si 0).
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { FiUsers, FiX } from 'react-icons/fi';
import { theme } from '../theme';
import { useAuth } from '../context/AuthContext';
import FriendsOnlineDock from './FriendsOnlineDock';
import FriendGroupsDock from './FriendGroupsDock';
import MesMessagesDock from './MesMessagesDock';

// Tout le composant est MOBILE-only (le desktop utilise les languettes flottantes).
const Wrap = styled.div`@media (min-width:768px){ display:none; }`;
// À la PLACE de « Chat communauté » sur mobile (bas-droite, proéminent, dégradé). position:fixed (le fixe
// établit le bloc conteneur pour le badge .cnt en absolute — pas besoin de position:relative, qui écraserait le fixe).
const Fab = styled.button`
  position:fixed;right:1.2rem;bottom:1.2rem;z-index:1500;
  display:inline-flex;align-items:center;gap:.5rem;white-space:nowrap;cursor:pointer;
  padding:.7rem 1.1rem;border-radius:999px;border:none;font-weight:700;font-size:.9rem;
  background:${theme.colors.gradient};color:#fff;box-shadow:${theme.shadows.glow};
  .cnt{position:absolute;top:-6px;right:-6px;min-width:18px;height:18px;padding:0 4px;border-radius:999px;background:#ef4444;color:#fff;
    font-size:.68rem;font-weight:800;display:inline-flex;align-items:center;justify-content:center;box-shadow:0 0 0 2px ${theme.colors.bgPrimary};}`;
const Backdrop = styled.div`
  position:fixed;inset:0;z-index:1598;background:rgba(0,0,0,.5);
  opacity:${({ $open }) => ($open ? 1 : 0)};pointer-events:${({ $open }) => ($open ? 'auto' : 'none')};
  transition:opacity .2s ease;`;
const Drawer = styled.aside`
  position:fixed;top:0;right:0;bottom:0;z-index:1599;width:min(340px,86vw);
  background:${theme.colors.bgPrimary};border-left:1px solid ${theme.colors.border};
  box-shadow:-8px 0 24px rgba(0,0,0,.35);display:flex;flex-direction:column;
  transform:translateX(${({ $open }) => ($open ? '0' : '100%')});transition:transform .22s ease;`;
const DHead = styled.div`display:flex;align-items:center;justify-content:space-between;padding:.9rem 1rem;
  background:${theme.colors.gradient};color:#fff;font-weight:800;font-size:.95rem;
  h4{display:flex;align-items:center;gap:.5rem;} button{background:none;border:none;color:#fff;cursor:pointer;display:flex;font-size:1.15rem;}`;
const DBody = styled.div`flex:1;overflow-y:auto;padding:.6rem .9rem 1.2rem;display:flex;flex-direction:column;gap:1rem;`;
const Empty = styled.p`color:${theme.colors.textMuted};font-size:.85rem;text-align:center;padding:2rem 1rem;`;

export default function SocialDock() {
  const { isLoggedIn } = useAuth();
  const [open, setOpen] = useState(false);
  const [c, setC] = useState({ friends: 0, groups: 0, msgs: 0 });
  // Setters STABLES + bail si inchangé → pas de boucle de rendu (onCount identité fixe, state non recréé si égal).
  const setFriends = useCallback((n) => setC((s) => (s.friends === n ? s : { ...s, friends: n })), []);
  const setGroups = useCallback((n) => setC((s) => (s.groups === n ? s : { ...s, groups: n })), []);
  const setMsgs = useCallback((n) => setC((s) => (s.msgs === n ? s : { ...s, msgs: n })), []);
  const total = c.friends + c.groups + c.msgs;

  if (!isLoggedIn) return null;

  return (
    <Wrap>
      {/* Bouton Social PERSISTANT (remplace « Chat communauté » sur mobile). Badge seulement si >0. */}
      <Fab onClick={() => setOpen(true)} title="Social : amis, groupes, messages">
        <FiUsers /> Social
        {total > 0 && <span className="cnt">{total}</span>}
      </Fab>
      <Backdrop $open={open} onClick={() => setOpen(false)} />
      {/* Le drawer reste MONTÉ (translaté hors écran) même fermé → les 3 docks continuent de compter. */}
      <Drawer $open={open} aria-hidden={!open}>
        <DHead>
          <h4><FiUsers /> Social</h4>
          <button onClick={() => setOpen(false)} title="Fermer"><FiX /></button>
        </DHead>
        <DBody>
          <FriendsOnlineDock mode="drawer" onCount={setFriends} />
          <FriendGroupsDock mode="drawer" onCount={setGroups} />
          <MesMessagesDock mode="drawer" onCount={setMsgs} />
          {total === 0 && <Empty>Aucun ami en ligne, groupe ou message pour le moment.</Empty>}
        </DBody>
      </Drawer>
    </Wrap>
  );
}
